import AxiosInitializer from 'api/Utility/AxiosInitializer'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import librariesFormattedResponses from 'api/ResponseFormats/Libraries'
import apiWrapper from 'api/Utility/ApiWrapper'
import getToken from 'lib/authentication/GetToken'

const axiosCommonReq = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const userEndPoints = {
  fetchIntercom: () => {
    //since we need to pass the data in snake_case to intercom , transformResConfig will be always false
    return axiosCommonReq({ transformResConfig: false }).get('/intercom')
  },
}

const { fetchIntercom } = userEndPoints
const { getIntercomResponse } = librariesFormattedResponses

const librariesApi = {
  fetchIntercom: () => {
    return apiWrapper({
      endPoint: fetchIntercom,
      responseFormat: getIntercomResponse,
      errorFailureAction: handleStatus500,
    })
  },
}

export default librariesApi
